import React, { useContext, useEffect, useState } from 'react';
import CheckoutSteps from '../components/general/CheckoutSteps';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Store } from '../Store';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

export default function PaymentMethodScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate(); // enables the functionality, to navigate a user to a different screen
  const { state, dispatch: ctxDispatch } = useContext(Store); // useContext gives access to the state of the context (in this case the Store) and lets me rename dispatch to ctxDisptach, to distinguish it from the dispatch of the current component
  const {
    userInfo,
    cart: { paymentMethod, cartItems },
  } = state; // gets the paymentMethod out of the application state (wich is either already filled in, if the user already entered this information before and is therefor stored in his localStorage, or an empty string) <- the logic of that can be found in the Store.js file

  const [paymentMethodName, setPaymentMethod] = useState(
    paymentMethod || 'paypal'
  ); // the paymentMethod is either the one out of the localStorage from the user, or by default 'paypal'

  useEffect(() => {
    if (!userInfo) {
      navigate('/signup?redirect=/cart'); // if the user isn't signed in, he can't access the PaymentMethodScreen and instead will be redirected to the SigninScreen. After sign in, the user will than be redirected to the CartScreen
    } else if (cartItems.length === 0) {
      navigate('/'); // if there are no items in the cart, the user cant access this screen
    }
  }, [userInfo, cartItems, navigate]); // no address check: the store defaults both addresses to an empty object, so a redirect for a missing one never fired (deleted Oct 2026); PlaceOrderScreen stops an incomplete address

  const submitHandler = (e) => {
    e.preventDefault(); // prevents a page refresh, when the Form will be submited
    ctxDispatch({
      type: 'SAVE_PAYMENT_METHOD',
      payload: paymentMethodName,
    }); // dispatches the 'SAVE_PAYMENT_METHOD' action to the Store (updates the state of the application)
    localStorage.setItem('paymentMethod', paymentMethodName); // safes the paymentMethodName in the browsers local storage (in this case, the localStorage is being modified here and not in the dispatched action in the store, because the paymentMethodName stored in localStorage is not directly related to the state management in the Store (seperation of concerns). Even though the modification of the data is the same in both cases, only if the data necessary to the localStorage 100% correlates with the data necessary to the application state, they can both be handled in the action of the Store)
    navigate('/placeorder'); // (implemented at the beginning of the function with the useNavigate() hook from react-router-dom) after the 'Continue' button is clicked, the user will be redirceted to the PlaceorderScreen
  };

  return (
    <Container className="checkout-steps-container">
      <div>
        {/* custom CheckoutSteps component with 'step1', 'step2' and 'step3' as active */}
        <CheckoutSteps step1 step2 step3></CheckoutSteps>

        <div className="container small-container">
          <title>{t('payment-method-screen-helmet')}</title>

          <h1 className="screen-heading">
            {t('payment-method-screen-heading')}
          </h1>

          <Form onSubmit={submitHandler}>
            <div className="payment-method-container">
              <label htmlFor="paypal">
                <div className="paypal-payment-container">
                  <Form.Check
                    type="radio"
                    id="paypal"
                    value="paypal"
                    checked={paymentMethodName === 'paypal'} // the Checkbox is checked, if the payment method is paypal
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  />
                  <div className="w-100 d-flex justify-content-center align-items-center">
                    <img
                      src="https://custom-keycaps-images.s3.eu-central-1.amazonaws.com/PayPal.png"
                      alt="PayPal"
                    />
                  </div>
                </div>
              </label>

              <label htmlFor="card">
                <div className="card-payment-container">
                  <Form.Check
                    type="radio"
                    id="card"
                    value="card"
                    checked={paymentMethodName === 'card'} // the Checkbox is checked, if the payment method is Debit/Credit Card
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  />
                  <div className="w-100 d-flex justify-content-center align-items-center">
                    <img
                      src="https://custom-keycaps-images.s3.eu-central-1.amazonaws.com/Mastercard.png"
                      alt="Mastercard"
                    />
                    <img
                      src="https://custom-keycaps-images.s3.eu-central-1.amazonaws.com/Visa.png"
                      alt="Visa"
                    />
                    <img
                      src="https://custom-keycaps-images.s3.eu-central-1.amazonaws.com/AmericanExpress.png"
                      alt="AmericanExpress"
                    />
                  </div>
                </div>
              </label>
            </div>

            <div className="my-5 d-flex justify-content-center">
              <Button variant="secondary" type="submit">
                {t('payment-method-screen-continue')}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Container>
  );
}
